import { render } from "./cotizacionComponent.vue?vue&type=template&id=124f6be9"
import script from "./cotizacionComponent.vue?vue&type=script&lang=js"
export * from "./cotizacionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__